import { styled } from "@mui/material/styles";
import { Popover } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const PhoneFramePopover = styled(Popover)(() => ({
  "& .MuiPopover-paper": {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
}));

export const PhoneFrame = styled("div")(() => ({
  position: "relative",
  width: "302px",
  height: "600px",
  backgroundColor: "#1a1a1a",
  borderRadius: "50px",
  padding: "12px",
  boxShadow: "0 50px 100px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)",
}));

export const PhoneScreen = styled("div")(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
  backgroundColor: "#ffffff",
  borderRadius: "42px",
  overflow: "hidden",
  boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
}));

export const StatusBar = styled("div")(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "44px",
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 20px",
  zIndex: 100,
}));

export const StatusBarTime = styled("span")(() => ({
  fontSize: "14px",
  fontWeight: 600,
  color: "#000000",
}));

export const StatusBarIcons = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
}));

export const DynamicIsland = styled("div")(() => ({
  position: "absolute",
  top: "10px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "60px",
  height: "20px",
  backgroundColor: "#000000",
  borderRadius: "20px",
  zIndex: 101,
}));

export const NavHeader = styled("div")(() => ({
  position: "absolute",
  top: "44px",
  left: 0,
  right: 0,
  height: "56px",
  backgroundColor: "#ffffff",
  display: "flex",
  flexDirection: "column",
  padding: "0 16px",
  gap: "8px",
}));

export const NavHeaderIcons = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}));

export const NavTitle = styled("span")(() => ({
  fontSize: "14px",
  fontWeight: 600,
  color: colors.brandBlue500,
  fontFamily: "Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const NavRightIcons = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
}));

export const NavTriggers = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  backgroundColor: colors.gray50,
  position: "absolute",
  top: "101px",
  left: 0,
  right: 0,
  padding: "8px 16px",
  borderBottom: `1px solid ${colors.gray200}`,
}));

export const NavTriggersText = styled("span")(() => ({
  fontSize: "12px",
  fontWeight: 400,
  color: colors.gray600,
  fontFamily: "Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ContentArea = styled("div")(() => ({
  position: "absolute",
  top: "138px",
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#f9fafb",
  overflowY: "auto",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const VolumeButton = styled("div")<{ position: "top" | "bottom" }>(({ position }) => ({
  position: "absolute",
  left: "-3px",
  width: "3px",
  height: "28px",
  backgroundColor: "#333333",
  borderRadius: "2px 0 0 2px",
  top: position === "top" ? "120px" : "160px",
}));

export const PowerButton = styled("div")(() => ({
  position: "absolute",
  right: "-3px",
  top: "150px",
  width: "3px",
  height: "60px",
  backgroundColor: "#333333",
  borderRadius: "0 2px 2px 0",
}));

export const HomeIndicator = styled("div")(() => ({
  position: "absolute",
  bottom: "8px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "134px",
  height: "5px",
  backgroundColor: "#000000",
  borderRadius: "100px",
  opacity: 0.3,
}));
